import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { BrandModalProvider } from "./context/BrandModalContext";
import { BrandSystemModal } from "./components/BrandSystemModal";
import Home from "./pages/Home";
import BrandSystem from "./pages/BrandSystem";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrandModalProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/brandsystem" element={<BrandSystem />} />
              <Route path="/brand-system" element={<BrandSystem />} />
            </Routes>
          </BrowserRouter>
          <BrandSystemModal />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#171713",
                color: "#F5F0E6",
                border: "1px solid rgba(185,151,79,0.4)",
                borderRadius: "2px",
                fontFamily: "Inter, sans-serif",
                letterSpacing: "0.03em",
              },
            }}
          />
        </BrandModalProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
